import { ItemTabs } from 'CMFW/layout/ItemTabs';
import { ModuleContainer } from 'components/common/styles';
import React from 'react';
import styled from 'styled-components';
import UnifiedDashboard from './tabs/UnifiedDashboard';
import UnifiedProjects from './tabs/UnifiedProjects';
import UnifiedBatch from './tabs/UnifiedBatch';

const TranslationUnified: React.FC = () => {
  return (
    <Container>
      <ItemTabs tabNames={['Dashboard', 'Projects', 'Bulk']}>
        <UnifiedDashboard />
        <UnifiedProjects />
        <UnifiedBatch />
      </ItemTabs>
    </Container>
  );
};

const Container = styled(ModuleContainer)`
  flex-direction: column;
  align-items: flex-start;
  padding-top: 5px;
  font-size: 15px;
`;

export default TranslationUnified;
